export const getLogo = (brand, brands, overrideLogo, cdnUrl, cmsLogoUrl) => {
	const logoBasePath = `${cdnUrl}/logos/brands/`;
	return overrideLogo
		? `${logoBasePath}${overrideLogo}.svg`
		: cmsLogoUrl || `${logoBasePath}${brands[brand].logo || `${brand}.svg`}`;
};

export const preloadLogoUrl = (logoUrl) => {
	if (!logoUrl) return;
	const selector = `link[rel="preload"][as="image"][href="${logoUrl}"]`;
	if (document.head.querySelector(selector)) return;
	const link = document.createElement("link");
	link.rel = "preload";
	link.as = "image";
	link.href = logoUrl;
	link.crossOrigin = "anonymous";
	document.head.appendChild(link);
};
